import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-catalyst-core/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Seo = makeShortcode("Seo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Seo title="Who" mdxType="Seo" />
    <h1 {...{
      "id": "whos-here"
    }}>{`Who’s here?`}</h1>
    <h2 {...{
      "id": "the-coalition-against-death-by-incarceration"
    }}>{`The Coalition Against Death by Incarceration`}</h2>
    <p><a parentName="p" {...{
        "href": "https://www.facebook.com/CADBIphilly",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`CADBI on facebook`}</a></p>
    <h2 {...{
      "id": "human-rights-coalition"
    }}>{`Human Rights Coalition`}</h2>
    <p>{` `}<a parentName="p" {...{
        "href": "https://hrcoalition.org",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`hrcoalition.org`}</a></p>
    <h2 {...{
      "id": "holobiont-lab"
    }}>{`Holobiont Lab`}</h2>
    <p><a parentName="p" {...{
        "href": "https://holobiontlab.org",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`holobiontlab.org`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      